import FeedbackPage from "@components/FeedbackPage"

export default function CalorieCountingPositive() {
  return (
    <FeedbackPage
      emoji="⭐"
      titleKey="pages.onboarding.calorieCountingPositive.heading"
      textKey="pages.onboarding.calorieCountingPositive.info"
    />
  )
}
